import { Card, CardContent, CardHeader, CardMedia, Container, Typography } from '@mui/material'
import React from 'react'
import Design from '../../assets/jpeg/design.jpeg'
import Visualize from '../../assets/png/visualize.png'
import Collaborate from '../../assets/jpeg/collaborate.jpeg'

const MissionStatement = (props) => {

  const features = [
    {
      title: "Design",
      subheader: "Custom garage layouts.",
      paragraph: "Design your garage in 2D or 3D. Place storage containers, desks, pegboards, hanging hooks, tools and more.",
      img: Design,
      imgAlt: "design graphic",
    },
    {
      title: "Visualize",
      subheader: "Your designs in 3D.",
      paragraph: "Walk around your future garage in 3D and feel what your space is going to look like. Explore your new reality.",
      img: Visualize,
      imgAlt: "visualize graphics",
    },
    {
      title: "Collaborate",
      subheader: "Work with anyone.",
      paragraph: "Design your garage in real-time with your stakeholders or clients. Use the tool to work on your space with anyone.",
      img: Collaborate,
      imgAlt: "collab graphics",
    },
  ]

  return (
    <Container sx={{mt: 2.5, display: "flex", flexWrap: "wrap", justifyContent: "center",}}>
      {
        features.map(feature => (
          <Card sx={{maxWidth: 345, m:1,}}>
            <CardHeader
              title={feature?.title}
              titleTypographyProps={{fontWeight: 600}}
              subheader={feature?.subheader}
            />
              <CardMedia
                component="img"
                height="194"
                image={feature?.img}
                alt={feature?.imgAlt}
              />
            <CardContent>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {feature?.paragraph}
              </Typography>
            </CardContent>
          </Card>
        ))
      }
    </Container>
  )
}

export default MissionStatement